export const DEFAULT_TOAST = {};
